import React from 'react';
import PropTypes from 'prop-types';
import Table, {
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
  } from 'material-ui/Table';
import Checkbox from 'material-ui/Checkbox';
import Tooltip from 'material-ui/Tooltip';

const createSortHandler = (property, event, props) => {
    props.onRequestSort(event, property);
};

let EnhancedTableHead = props => {
      const { onSelectAllClick, order, orderBy, numSelected, rowCount, columnData, translate } = props;
  
      return (
        <TableHead>
          <TableRow>
            {/*
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
              />
            </TableCell>*/
            }
            {columnData.map(column => {
              return (
                <TableCell
                  key={column.id}
                  numeric={column.numeric}
                  padding={column.disablePadding ? 'none' : 'default'}
                  style={column.style}
                >
                  {column.noHeader?null:(
                    <Tooltip
                    title="Sort"
                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                     <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={(property,event)=>createSortHandler(column.id, event, props)}
                    >
                      {translate?translate(column.label):column.label}
                    </TableSortLabel>
                   
                  </Tooltip>
                  )}
                </TableCell>
              );
            }, this)}
          </TableRow>
        </TableHead>
      );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    columnData: PropTypes.array.isRequired
};

export default EnhancedTableHead;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/DataTable/EnhancedTableHead.js